import React from 'react';
import { determineLeftNavAppearance } from '@bbkAdminRedux/app/reducers';
import { cs } from '@bbkAdminUtils/css-utils';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';
import { useLocation } from '@bbkShared/react-router';

import './styles/layout.scss';

export const MainContent: ReactFCC = ({ children }) => {
  const location = useLocation();
  const showNav = determineLeftNavAppearance(location.pathname);
  return (
    <div
      className={cs('main-content', { 'full-screen': !showNav })}
      id="main-content"
    >
      {children}
    </div>
  );
};
